import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  HStack,
  GridItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { ColorModeSwitcher } from "../ColorModeSwitcher";

export const Nav = (props) => {
  const page = props.page;
  let navigate = useNavigate();

  const [brand, setBrand] = useState(false);
  const [admin, setAdmin] = useState(false);

  useEffect(() => {
    const rawJWT = localStorage.getItem("jwtToken");
    if (!rawJWT) {
      //TODO: log user out
      return;
    }
    const jwt = rawJWT.split("Bearer ")[1];
    if (!jwt || jwt === "") {
      return;
    }
    const payload = atob(jwt.split(".")[1]);
    const parsedJWT = JSON.parse(payload);
    setBrand(parsedJWT?.organization);
    setAdmin(parsedJWT.isAdmin);
  });

  const lightGray = useColorModeValue("gray.200", "gray.100");
  const darkGray = useColorModeValue("gray.600", "gray.600");

  return (
    <GridItem
      pl="2"
      area={"header"}
      bg={useColorModeValue("gray.600", "gray.600")}
    >
      <Flex>
        <Box ml="2" my="3" width="100%">
          <Heading
            color={useColorModeValue("gray.100", "gray.100")}
            fontSize="2xl"
          >
            <Link to={brand ? "/brandCampaigns" : "/home"}>HUBIT</Link>
          </Heading>
        </Box>
        <Box mt="1" mx="3">
          <HStack>
            {page && page === "login" && (
              <Box>
                <Button
                  onClick={() => {
                    return navigate("/loginBrand");
                  }}
                  colorScheme="teal"
                >
                  Production company
                </Button>
              </Box>
            )}
            {page && page === "loginBrand" && (
              <Box>
                <Button
                  onClick={() => {
                    return navigate("/login");
                  }}
                  colorScheme="teal"
                >
                  User login
                </Button>
              </Box>
            )}
            {!page && (
              <>
                {brand && (
                  <Box>
                    <Button
                      onClick={() => {
                        return navigate("/brandCampaigns/reports");
                      }}
                      color={lightGray}
                      bg={darkGray}
                    >
                      Reports
                    </Button>
                  </Box>
                )}
                {!brand && !admin && (
                  <Box>
                    <Button
                      onClick={() => {
                        return navigate("/ratings");
                      }}
                      color={lightGray}
                      bg={darkGray}
                    >
                      Ratings
                    </Button>
                  </Box>
                )}
                <Box>
                  <Menu>
                    <MenuButton color={lightGray} bg={darkGray} as={Button}>
                      Settings
                    </MenuButton>
                    <MenuList color={darkGray}>
                      {!admin && (
                        <MenuItem
                          onClick={() =>
                            navigate(brand ? `/brand/${brand}` : "/userProfile")
                          }
                        >
                          Profile
                        </MenuItem>
                      )}
                      {brand && (
                        <MenuItem
                          onClick={() =>
                            navigate(brand ? "/brandAccount" : "/userAccount")
                          }
                        >
                          Account
                        </MenuItem>
                      )}
                      <MenuItem
                        onClick={() => {
                          localStorage.removeItem("jwtToken");
                          return navigate("/login");
                        }}
                      >
                        Log Out
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Box>
              </>
            )}
            <Box color={lightGray}>
              <ColorModeSwitcher justifySelf="flex-end" />
            </Box>
          </HStack>
        </Box>
      </Flex>
    </GridItem>
  );
};
